module.exports = __webpack_public_path__ + "img/option_icon.be3e8626.svg";